const modalManager = {
    modalExists: function (modalType) {
        return $(`[data-modal="${modalType}"]`).length > 0;
    },

    insertData: function (dataObj, modalType) {
        const modal = $(`[data-modal="${modalType}"]`);
        if (!modal.length) return;

        if (Object.keys(dataObj).length > 0) {
            Object.keys(dataObj).forEach(function (key) {
                const input = modal.find(`input[name="${key}"]`);
                if (input.length) {
                    input.val(dataObj[key]);
                }
            });
        }

        if (dataObj && typeof dataObj.gtm === 'object' && dataObj.gtm !== null) {
            const inputIndex = modal.find(`input[name=gtm_item]`);
            const inputItemName = modal.find(`input[name=gtm_item_name]`);

            if (inputIndex.length && 'index' in dataObj.gtm) {
                inputIndex.val(dataObj.gtm.index);
            }

            if (inputItemName.length && 'item_list_name' in dataObj.gtm) {
                inputItemName.val(dataObj.gtm.item_list_name);
            }
        }
    },

    handleModalAction: function (modalType, extraData) {
        if (modalManager.modalExists(modalType)) {
            modalManager.showModal(modalType);
            return;
        }

        modalManager.loadModal(modalType, extraData).done(function (response) {
            if (response.status === 'success') {
                modalManager.closeAllModal();
                $('body').append(response.html);
                modalManager.showModal(modalType);
                modalManager.insertData(extraData, modalType);
                const modalWrapper = $(`.js_modal[data-modal=${modalType}]`)
                if (modalWrapper.find('.js_select__phone-code').length) {
                    phoneTools.getPhoneCodes(modalWrapper.find('.js_select__phone-code'))
                    selectTools.selectItemInit(modalWrapper.find('.js_select__phone-code'))
                    phoneTools.initIntValueItem(modalWrapper.find('input[name=phone]'))
                } else if (modalWrapper.find('.js_phone_input').length) {
                    phoneTools.initPhoneMaskItem(modalWrapper.find('input[name=phone]')[0])
                }
            } else {
                console.error('Failed to load modal:', response);
            }
        }.bind(this)).fail(function (jqXHR, textStatus, errorThrown) {
            console.error('Error loading modal:', textStatus, errorThrown);
        });
    },

    showModal: function (modalType) {
        const modal = $(`[data-modal="${modalType}"]`);

        if (modal.length) {
            modal.addClass('active');
        }
    },

    closeModal: function (modal) {
        if (!modal.length) return;
        const removeModal = modal.data('remove-modal') === true;
        modal.removeClass('active');
        if (removeModal) {
            modal.remove();
        }
    },

    closeAllModal: function (modal) {
        $(`[data-modal]`).each(function () {
            const modal = $(this);
            if (modal.attr('data-remove-modal') == 'true') {
                modal.remove();
            } else {
                modal.removeClass('active')
            }
        })
    },

    loadModal: function (modalType, extraData) {
        return $.ajax({
            url: requests.createModalPage,
            method: 'POST',
            data: { type: modalType, ...extraData },
            dataType: 'json'
        });
    }
};

$(document).on('click', '[data-load-modal]', function (e) {
    e.preventDefault();
    const modalType = $(this).data('load-modal');
    const extraData = {
        good_id: $(this).data('id') || null,
        gtm_item_list: $(this).data('item-list') || null,
        gtm_item: $(this).data('index') || null,
    };
    modalManager.handleModalAction(modalType, extraData);
});

$(document).on('click', '.js_modal', function (e) {
    if (e.target === this) {
        const modal = $(this);
        modalManager.closeModal(modal);
    }
});

$(document).on('click', '.js_modal__close', function () {
    const modal = $(this).closest('.js_modal');
    modalManager.closeModal(modal);
});

window.handleModalAction = modalManager.handleModalAction;
window.closeAllModal = modalManager.closeAllModal;
